var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.error.statusCode === 404
        ? [_c("not-found")]
        : [
            _c("errorPage", {
              attrs: {
                "error-code": _vm.error.statusCode,
                message: _vm.error.message,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }